import React, { useEffect, useState } from "react";
import LedgerTable from "../components/LedgerTable";
import AddEntryModal from "../components/AddEntryModal";
import FilterBar from "../components/FilterBar";
import LedgerHeader from "../components/LedgerHeader";
import AddAccountModal from "../components/AddAccountModal";
import "../style/ledger.css";
import { useLedgerAccountContext } from "../context/ledgerAccount_context"; // 👈 context import
import { useLedgerEntryContext } from "../context/ledgerEntry_context";

// Initial mock accounts
const initialAccounts = [
  { account_name: "Cash", opening_balance: 5000, current_balance: 5000 },
  { account_name: "PSB Online", opening_balance: 10000, current_balance: 10900 },
  { account_name: "SBI Online", opening_balance: 8000, current_balance: 7450 },
];

// Initial mock entries (could later be grouped by account if needed)
const mockLedgerEntries = [
  { id: 1, entry_date: "2025-05-01", description: "Office Supplies", amount: 500, category: "Office", account_name: "Cash" },
  { id: 2, entry_date: "2025-05-03", description: "Client Payment", amount: 1500, category: "Income", account_name: "Cash" },
  { id: 3, entry_date: "2025-05-05", description: "Electricity Bill", amount: 600, category: "Utilities", account_name: "PSB Online" },
  { id: 4, entry_date: "2025-05-08", description: "Travel Expense", amount: 300, category: "Travel", account_name: "SBI Online" },
  // ... more entries
];

const LedgerPage = () => {
  const { ledgerAccounts } = useLedgerAccountContext();
  const { ledgerEntries,fetchLedgerEntries } = useLedgerEntryContext();
  console.log("mani in ledgerAccounts");
  console.log(ledgerAccounts);
  console.log("mani in ledgerEntries");
  console.log(ledgerEntries);

  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null); // default to first account
  const [entries, setEntries] = useState([]);
 
  const [showModal, setShowModal] = useState(false);
  const [showAccountModal, setShowAccountModal] = useState(false);

  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    category: "",
  });

  useEffect(() => {
    if (Array.isArray(ledgerAccounts)) {
      setAccounts(ledgerAccounts);
    }
  }, [ledgerAccounts]);

  // On mount, inject mock entries
  useEffect(() => {
    setEntries(ledgerEntries);
  }, [ledgerEntries]);

  useEffect(() => {
    fetchLedgerEntries(filters);
  }, [filters]);
 
  const handleAddEntry = (newEntry) => {
    const entryWithAccount = { ...newEntry, account_name: selectedAccount.account_name };
    setEntries(prev => [...prev, entryWithAccount]);
    setShowModal(false);
  };

  const handleAddAccount = (newAccount) => {
    setAccounts(prev => [...prev, newAccount]);
    setShowAccountModal(false);
  };

  const handleDownloadCSV = () => {
    const headers = ["Date", "Description", "Amount", "Category"];
    const rows = entries.map(entry =>
      [entry.entry_date, entry.description, entry.amount, entry.category]
    );
    const csvContent =
      [headers, ...rows].map(e => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ledger.csv";
    a.click();
  };

  return (
    <div className={`ledger-page ${showModal || showAccountModal ? "blurred" : ""}`}>
      {/* Header with account dropdown */}
      <LedgerHeader
        accounts={accounts}
        selectedAccount={selectedAccount}
        onAccountChange={setSelectedAccount}
        onAddClick={() => setShowAccountModal(true)}
      />

      <h2>Filter </h2>

      <div className="button-group">
        <FilterBar filters={filters} setFilters={setFilters} />
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <button onClick={() => setShowModal(true)} className="add-entry-btn">
            + Add Entry
          </button>
          <button onClick={handleDownloadCSV} className="add-entry-btn">
            ⬇️ Download CSV
          </button>
        </div>
      </div>

      <LedgerTable entries={entries} />

      {showModal && (
        <AddEntryModal
          onClose={() => setShowModal(false)}
          
          accounts={accounts} // ✅ Pass accounts here
        />
      )}

      {showAccountModal && (
        <AddAccountModal
          onClose={() => setShowAccountModal(false)}
          onSubmit={handleAddAccount}
        />
      )}
    </div>
  );
};

export default LedgerPage;
